<div class="bg-white border-2 border-primary-400 rounded-lg shadow-md overflow-hidden w-full">
  <div class="px-4 py-3 flex items-start gap-3">
    <!-- Index badge -->
    <span
      class="shrink-0 flex items-center justify-center w-7 h-7 rounded-full bg-primary-500 text-white text-xs font-bold leading-none"
    >
      {{ data().index + 1 }}
    </span>

    <!-- Text content -->
    <div class="flex flex-col min-w-0 gap-0.5">
      <span class="text-sm font-semibold text-gray-900 break-words" [innerHTML]="data().value | highlightVariables"></span>
      <span class="text-xs text-gray-500">
        {{ data().children.length }}
        {{ data().children.length === 1 ? 'antwoord' : 'antwoorden' }}
      </span>
    </div>
  </div>
</div>
